export default __webpack_public_path__ + "static/media/deloitte2021gacs.95d91068.jpg";